import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.25 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ children, dark = false }) => (
  <Reveal>
    <span
      className={`inline-block font-mono text-[10px] sm:text-xs tracking-[0.4em] uppercase mb-6 ${
        dark ? "text-[var(--gold)]" : "text-[var(--gold-dark)]"
      }`}
    >
      {children}
    </span>
  </Reveal>
);

/* masked line-by-line reveal for headings */
export const MaskLines = ({ lines, className = "" }) => (
  <motion.span
    className="inline-block align-top"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.2 }}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.22em]">
        <motion.span
          className={`block ${className}`}
          variants={{ hidden: { y: "115%" }, show: { y: 0 } }}
          transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
